
import axios, { AxiosResponse } from "axios";
import { Component, Vue, Watch } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import UmbracoApiService from "@/services/UmbracoApiService";
import TuEstadoCuentaForm from "@/components/Tu_Estado_Cuenta/TuEstadoCuentaForm.vue";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import WsdlService from "@/services/WsdlService";
import TuEstadoCuentaResult from "@/components/Tu_Estado_Cuenta/TuEstadoCuentaResult.vue";
import Swal from "sweetalert2";
import EstadoDeCuentaModel from "@/models/TuEstadoCuenta/TuEstadoCuentaModel";
import FundType from "@/models/WsdlResponses/FundType";
import Months from "@/enums/MonthsEnum";
import Axios from "axios";
import MatrixPicker from "@/components/Matrix_Picker/MatricPicker.vue";
import MatrixItemClass from "@/models/MatrixPicker/MatrixItemClass";
import EstadoCuentaService from "@/services/EstadoCuentaService";
import Corte from "@/models/EstadoCuenta/Corte";
import FechaCorte from "@/models/EstadoCuenta/FechaCorte";
import AfiliadoService from "@/services/AfiliadoService";

import { uid } from "ets-fingerprintjs";
import EstadoCuentaPDFRequest, {
  AuditAttributes,
  PDFAttributes,
} from "@/models/EstadoCuenta/EstadoCuentaPDFRequest";
@Component({
  components: {
    TuEstadoCuentaForm,
    TuEstadoCuentaResult,
    MatrixPicker,
  },
})
export default class NewEstadoDeCuenta extends Vue {
  public isLoading: boolean = false;
  public tipoFondo: Array<FundTypeObj> = [];
  public wsdlService: WsdlService = new WsdlService();
  public umbracoService = new UmbracoApiService();
  public userId: string = this.$store.state.user.cedula;
  public showResult: boolean = false;
  public umbracoBaseUrl: string = GlobalConfig.UMBRACO_BASE_URL;
  public labelData = new EstadoDeCuentaModel();
  public afiliado: any = {};
  public saldos: any = {};
  public conceptos: any = {};
  public movimientos: any = {};
  public eDC: any = {};
  public iniDate: string = "";
  public FinDate: string = "";
  public fechaHasta: string = "02/06/2022";
  public fechaDesde: string = "03/12/2003";
  /////////////
  EstadoCuentaService: EstadoCuentaService = new EstadoCuentaService();
  public fechaCorte: Array<FechaCorte> = [];
  public matrixItems: Array<MatrixItemClass> = [];
  public matrixItemsCorte: Array<MatrixItemClass> = [];
  public estadoAnio: string = "";
  public estadoCorte: string = "";
  public base64: string = "";
  public showPDF: boolean = false;
  public isPdfSupported: boolean = false;
  public base64view: string = "";
  public pdfUrl: string = "";
  public loadingPage = true;
  public fileName: string = "Estado de Cuenta";
  public showErrorMessage = false;
  public matrixItem: MatrixItemClass = new MatrixItemClass("2021", "ddd", "00");
  public currentCorteSelected: Corte = new Corte();
  public OS: string = "";
  public browser: string = "";
  public ip: string = "";
  public afiliadoService: AfiliadoService = new AfiliadoService();
  public matrixItem1: MatrixItemClass = new MatrixItemClass(
    "2021",
    "ddd",
    "01"
  );
  public matrixItem2: MatrixItemClass = new MatrixItemClass(
    "2021",
    "ddd",
    "02"
  );
  public matrixItem3: MatrixItemClass = new MatrixItemClass(
    "2021",
    "ddd",
    "03"
  );
  public matrixItem4: MatrixItemClass = new MatrixItemClass(
    "2021",
    "ddd",
    "04"
  );
  /////////////

  constructor() {
    super();
  }
  async mounted() {
    const user = this.$store.state.user;

    this.loadingPage = true;
    this.EstadoCuentaService.getFechaCorte(
      user.cedula,
      user.userIdentityEncrypt,
      user.TokenGenerate
    )
      .then((x) => {
        console.log("getFechaCorte", x);
        this.fechaCorte = x.data.payload.data;
        this.loadingPage = false;
      })
      .catch((x) => {
        this.loadingPage = false;
        this.showErrorMessage = true;
      });

    await this.getLabelData();
    this.getBrowserInfo();
    this.ip = (await this.afiliadoService.getUserIpAddress()).data.ip;
  }
  public async getLabelData() {
    this.labelData = await this.umbracoService.getEstadoDeCuenta();
  }
  public checkPdfSupport() {
    const canvas = document.createElement("canvas");
    this.isPdfSupported = !!(canvas.getContext && canvas.getContext("2d"));
  }
  @Watch("fechaCorte")
  public fechaCortesWatch(value: Array<FechaCorte>) {
    value.forEach((x, index) => {
      let item = new MatrixItemClass(
        x.year?.toString(),
        " ",
        x.year?.toString(),
        index
      );
      this.matrixItems.push(item);
    });
  }
  ////////////////////////////////////

  private blobUrl: string | null = null;

  @Watch("base64")
  onBase64Change(newBase64: string) {
    if (!newBase64) return;

    // Construir Blob (PDF)
    const binStr = atob(newBase64);
    const len = binStr.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) bytes[i] = binStr.charCodeAt(i);
    const blob = new Blob([bytes], { type: "application/pdf" });

    // Revocar URL previa si existe
    if (this.blobUrl) URL.revokeObjectURL(this.blobUrl);

    // Crear URL blob y asignarla al iframe
    this.blobUrl = URL.createObjectURL(blob);
    this.pdfUrl = this.blobUrl;
  }

  // Limpieza para evitar fugas de memoria
  beforeDestroy() {
    if (this.blobUrl) URL.revokeObjectURL(this.blobUrl);
  }

  public async getAfiliado(tipoFondo: FundType) {
    await this.wsdlService
      .GetDataCuenta(this.userId, tipoFondo.codcuenta)
      .then((response: AxiosResponse<Array<any>>) => {
        this.afiliado = response.data[0];
      });
  }

  public returnForm() {
    this.showResult = false;
  }

  public anioSelected(value) {
    let filtered = this.fechaCorte.filter(
      (x) => x.year.toString() == value.toString()
    );
    if (filtered != null && filtered.length > 0) {
      this.matrixItemsCorte = [];
      filtered[0].periodos.forEach((x) => {
        let item = new MatrixItemClass(
          x.titulo?.toString(),
          `${x.fechaDesde} a ${x.fechaHasta}`,
          x.periodo?.toString()
        );
        this.matrixItemsCorte.push(item);
      });
    }
    this.estadoAnio = value;
    this.estadoCorte = "";
  }
  public corteSelected(value) {
    let filteredYear = this.fechaCorte.filter(
      (x) => x.year.toString() == this.estadoAnio.toString()
    );
    if (filteredYear != null && filteredYear.length > 0) {
      this.currentCorteSelected = filteredYear[0].periodos.find(
        (x) => x.periodo == value
      );
    }

    this.estadoCorte = value;
    console.log("Corte" + value);
  }

  get allowProcess() {
    return this.estadoAnio.length > 0 && this.estadoCorte.length > 0;
  }

  public getEDCPDF() {
    if (!this.allowProcess) {
      return false;
    }
    this.showLoadingAlert(
      "Valoramos tu tiempo. Este proceso puede tomar unos minutos. Gracias por utilizar nuestra plataforma digital."
    );
    this.loadingPage = true;

    let auditAttributes = new AuditAttributes(
      this.browser,
      this.OS,
      this.ip?.toString(),
      " "
    );
    let pdfAttributes = new PDFAttributes(this.currentCorteSelected.fileName);
    const user = this.$store.state.user;
    console.log("this.currentCorteSelected", this.currentCorteSelected);
    console.log("user", user);
    let payload = new EstadoCuentaPDFRequest(
      user.userIdentityEncrypt,
      user.TokenGenerate,
      this.currentCorteSelected.codCuenta,
      this.currentCorteSelected.nroLot,
      this.currentCorteSelected.periodo,
      auditAttributes,
      pdfAttributes
    );

    this.EstadoCuentaService.getEDCPdfBase64(payload)
      .then((x) => {
        if (
          x.data.payload.success == true &&
          x.data.payload.data?.pdfBase64 != null
        ) {
          this.base64 = x.data.payload.data.pdfBase64;
          this.showPDF = true;
          this.checkPdfSupport();
        } else {
          this.showErrorMessage = true;
        }
        this.loadingPage = false;
        Swal.close();
      })
      .catch((e) => {
        this.loadingPage = false;
        Swal.close();
      });
  }

  public downloadFilePDF(fileName, uri) {
    try {
      const dataURI = uri;
      const blob = this.dataURIToBlob(dataURI);
      const url = URL.createObjectURL(blob);
      const blobAnchor = document.createElement("a");
      const dataURIAnchor = document.createElement("a");
      blobAnchor.download = dataURIAnchor.download = fileName;
      blobAnchor.className = "hidden";
      blobAnchor.href = url;
      dataURIAnchor.href = dataURI;
      document.body.appendChild(blobAnchor);
      blobAnchor.onclick = function () {
        requestAnimationFrame(function () {
          URL.revokeObjectURL(url);
          setTimeout(() => blobAnchor.remove(), 300);
        });
      };
      blobAnchor.click();
    } catch (error) {
      this.showErrorMessage = true;
    }
  }
  public dataURIToBlob(dataURI) {
    const binStr = atob(dataURI),
      len = binStr.length,
      arr = new Uint8Array(len),
      mimeString = "application/pdf";
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], {
      type: mimeString,
    });
  }
  returnHome() {
    this.$router.push("/Dashboard");
  }

  refreshPage() {
    location.reload();
  }
  goMiInversion() {
    this.$router.push("/mi-inversion");
  }

  getBrowserInfo() {
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browser = navigator.appName;
    var version = "" + parseFloat(nVer);
    var nameOffset, verOffset, ix;

    // Yandex Browser
    if ((verOffset = nAgt.indexOf("YaBrowser")) != -1) {
      browser = "Yandex";
      version = nAgt.substring(verOffset + 10);
    }
    // Samsung Browser
    else if ((verOffset = nAgt.indexOf("SamsungBrowser")) != -1) {
      browser = "Samsung";
      version = nAgt.substring(verOffset + 15);
    }
    // UC Browser
    else if ((verOffset = nAgt.indexOf("UCBrowser")) != -1) {
      browser = "UC Browser";
      version = nAgt.substring(verOffset + 10);
    }
    // Opera Next
    else if ((verOffset = nAgt.indexOf("OPR")) != -1) {
      browser = "Opera";
      version = nAgt.substring(verOffset + 4);
    }
    // Opera
    else if ((verOffset = nAgt.indexOf("Opera")) != -1) {
      browser = "Opera";
      version = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf("Version")) != -1) {
        version = nAgt.substring(verOffset + 8);
      }
    }
    // Legacy Edge
    else if ((verOffset = nAgt.indexOf("Edge")) != -1) {
      browser = "Microsoft Legacy Edge";
      version = nAgt.substring(verOffset + 5);
    }
    // Edge (Chromium)
    else if ((verOffset = nAgt.indexOf("Edg")) != -1) {
      browser = "Microsoft Edge";
      version = nAgt.substring(verOffset + 4);
    }
    // MSIE
    else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
      browser = "Microsoft Internet Explorer";
      version = nAgt.substring(verOffset + 5);
    }
    // Chrome
    else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
      browser = "Chrome";
      version = nAgt.substring(verOffset + 7);
    }
    // Safari
    else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
      browser = "Safari";
      version = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf("Version")) != -1) {
        version = nAgt.substring(verOffset + 8);
      }
    }
    // Firefox
    else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
      browser = "Firefox";
      version = nAgt.substring(verOffset + 8);
    }
    // MSIE 11+
    else if (nAgt.indexOf("Trident/") != -1) {
      browser = "Microsoft Internet Explorer";
      version = nAgt.substring(nAgt.indexOf("rv:") + 3);
    }
    // Other browsers
    else if (
      (nameOffset = nAgt.lastIndexOf(" ") + 1) <
      (verOffset = nAgt.lastIndexOf("/"))
    ) {
      browser = nAgt.substring(nameOffset, verOffset);
      version = nAgt.substring(verOffset + 1);
      if (browser.toLowerCase() == browser.toUpperCase()) {
        browser = navigator.appName;
      }
    }

    this.browser = browser;

    var os;
    var clientStrings = [
      { s: "Windows 10", r: /(Windows 10.0|Windows NT 10.0)/ },
      { s: "Windows 8.1", r: /(Windows 8.1|Windows NT 6.3)/ },
      { s: "Windows 8", r: /(Windows 8|Windows NT 6.2)/ },
      { s: "Windows 7", r: /(Windows 7|Windows NT 6.1)/ },
      { s: "Windows Vista", r: /Windows NT 6.0/ },
      { s: "Windows Server 2003", r: /Windows NT 5.2/ },
      { s: "Windows XP", r: /(Windows NT 5.1|Windows XP)/ },
      { s: "Windows 2000", r: /(Windows NT 5.0|Windows 2000)/ },
      { s: "Windows ME", r: /(Win 9x 4.90|Windows ME)/ },
      { s: "Windows 98", r: /(Windows 98|Win98)/ },
      { s: "Windows 95", r: /(Windows 95|Win95|Windows_95)/ },
      { s: "Windows NT 4.0", r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
      { s: "Windows CE", r: /Windows CE/ },
      { s: "Windows 3.11", r: /Win16/ },
      { s: "Android", r: /Android/ },
      { s: "Open BSD", r: /OpenBSD/ },
      { s: "Sun OS", r: /SunOS/ },
      { s: "Chrome OS", r: /CrOS/ },
      { s: "Linux", r: /(Linux|X11(?!.*CrOS))/ },
      { s: "iOS", r: /(iPhone|iPad|iPod)/ },
      { s: "Mac OS X", r: /Mac OS X/ },
      { s: "Mac OS", r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
      { s: "QNX", r: /QNX/ },
      { s: "UNIX", r: /UNIX/ },
      { s: "BeOS", r: /BeOS/ },
      { s: "OS/2", r: /OS\/2/ },
      {
        s: "Search Bot",
        r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/,
      },
    ];
    for (var id in clientStrings) {
      var cs = clientStrings[id];
      if (cs.r.test(nAgt)) {
        os = cs.s;
        break;
      }
    }

    var osVersion;

    if (/Windows/.test(os)) {
      osVersion = /Windows (.*)/.exec(os)[1];
      os = "Windows";
    }

    switch (os) {
      case "Mac OS":
      case "Mac OS X":
      case "Android":
        osVersion =
          /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(
            nAgt
          )[1];
        break;

      case "iOS":
        osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
        osVersion =
          osVersion[1] + "." + osVersion[2] + "." + (osVersion[3] | 0);
        break;
    }

    this.OS = os + " " + osVersion;
  }

  public showLoadingAlert(message: string): void {
    Swal.fire({
      text: message,
      icon: "info",
      customClass: {
        container: "swal-container",
        popup: "swal-popup",
        title: "swal-title",
        content: "swal-content",
        confirmButton: "swal-button",
      },
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
      backdrop: true,
    });
  }
}
